export const TIMEZONE_TAB_TEXT = {
	myTime: 'My time',
	stationTime: 'Station time',
};
